import { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import Files from '.';
import Create from './create';
import Edit from './[id]';

const FilesRoutes: FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Files />} />
      <Route path="/create" element={<Create />} />
      <Route path="/:id" element={<Edit />} />
    </Routes>
  );
};

export default FilesRoutes;
